export default "/images/vendor/flag-icon-css/flags/1x1/rw.svg?02a8a07e06e4ae9c012213554233b005";